import { Link, useNavigate } from "react-router-dom";
import { logout, getCurrentUser } from "../services/authService";

export default function Navbar() {
  const navigate = useNavigate();
  const user = getCurrentUser();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <nav className="navbar">
      <div className="navbar-links">
        <Link to="/dashboard">Tableau de bord</Link>
        <Link to="/amis">Amis</Link>
      </div>
      <div className="navbar-user">
        <span>{user?.pseudo}</span>
        <button onClick={handleLogout} className="btn-ghost">Déconnexion</button>
      </div>
    </nav>
  );
}
